import { render, staticRenderFns } from "./MoreLink.vue?vue&type=template&id=29105c56&"
import script from "./MoreLink.vue?vue&type=script&lang=ts&"
export * from "./MoreLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports